<template lang="pug">
  div
    b-form(@submit='onSubmit' @reset='onReset' v-if='show')
        h3 Datos de cliente
        pre(v-if="verbose") {{ operation }}
        //b-form-group#input-firstName-group(label='Nombres:' label-for='input-firstName')
          b-form-input#input-firstName(v-model='form.firstName' placeholder='Nombres del cliente' :disabled="!editable")
        b-form-group#input-firstName-group(label='Nombres:' label-for='input-firstName' :disabled="!editable || form.isExistingClient")
          vue-bootstrap-typeahead#input-firstName(@hit='autofill($event, form)' v-model="form.firstName" :data="clients | readableClients" ref="firstName" :disabled="!editable || form.isExistingClient")
        //b-form-group#input-lastName-group(label='Apellidos:' label-for='input-lastName')
          b-form-input#input-lastName(v-model='form.lastName' placeholder='Apellidos del cliente' :disabled="!editable")
        b-form-group#input-lastName-group(label='Apellidos:' label-for='input-lastName' :disabled="!editable  || form.isExistingClient")
          vue-bootstrap-typeahead#input-lastName(@hit='autofill($event, form)' v-model="form.lastName" :data="clients | readableClients" ref="lastName" :disabled="!editable || form.isExistingClient")
        b-form-group#input-documentType-group(label='Tipo de documento:' label-for='input-documentType')
          b-form-select#input-documentType(v-model='form.documentType' :options='documentTypes' required='' placeholder='Tipo de documento' :disabled="!editable || form.isExistingClient")
        //b-form-group#input-documentNumber-group(:label='"Número de " + ( form.documentType || "documento" ) + ":"' label-for='input-documentNumber')
          b-form-input#input-documentNumber(v-model='form.documentNumber' :placeholder='"Número de " + ( form.documentTypeID || "documento" ) ' :disabled="!editable")
        b-form-group#input-documentNumber-group(:label='"Número de " + ( form.documentType || "documento" ) + ":"' label-for='input-documentNumber' :disabled="!editable || form.isExistingClient")
          vue-bootstrap-typeahead#input-documentNumber(@hit='autofill($event, form)' v-model="form.documentNumber" :data="clients | readableClients" ref="documentNumber" :disabled="!editable || form.isExistingClient")
        b-form-group#input-phoneNumber-group(label='Número de teléfono:' label-for='input-phoneNumber')
          b-form-input#input-phoneNumber(v-model='form.phone' placeholder='Teléfono' :disabled="!editable || form.isExistingClient")
        b-form-group#input-email-group(label='Correo electrónico:' label-for='input-email')
          b-form-input#input-email(v-model='form.email' type='email' placeholder='Correo electrónico' :disabled="!editable || form.isExistingClient")
        b-form-group#input-homeAddress-group(label='Dirección:' label-for='input-homeAddress')
          b-form-input#input-homeAddress(v-model='form.address' placeholder='Dirección' :disabled="!editable || form.isExistingClient")
        b-form-group#input-occupation-group(label='Ocupación:' label-for='input-occupation')
          b-form-input#input-occupation(v-model='form.occupation' placeholder='Ocupación' :disabled="!editable || form.isExistingClient")
        b-form-group#input-maritalStatus-group(label='Estado civil:' label-for='input-maritalStatus')
          b-form-select#input-maritalStatus(v-model='form.maritalStatus' :options='maritalStatusList' placeholder='Estado civil' :disabled="!editable || form.isExistingClient")
        h3 Ruta
        b-form-group#input-searchLocation-group(v-if="airports.length > 0 && editable" label='Buscar:' label-for='input-searchLocation' :disabled="!editable")
          vue-bootstrap-typeahead#input-searchLocation(v-model="form.searchLocation" :data="airports | readableAirports " ref="searchLocation" :disabled="!editable")
        b-form-group#input-searchLocation-group(v-if="editable" label='Fecha:' label-for='locationDate-input' :disabled="!editable")
          b-input-group#input-locationDate-group
            b-form-input#locationDate-input(v-model="form.locationDate" type="text" placeholder="YYYY-MM-DD" autocomplete="off")
            b-input-group-append
              b-form-datepicker#input-locationDate(v-model="form.locationDate" :disabled="!editable" button-only right aria-controls="locationDate-input")
        b-form-group#input-locationTime-group(v-if="editable" label='Hora:' label-for='input-locationTime')
          b-form-timepicker#input-locationTime(v-model="form.locationTime" :disabled="!editable")
        b-form-group#locationsButtons(v-if="editable")
          b-button.mr-sm-2(type='button' variant='primary' v-on:click='addLocation()') Añadir
          b-button(type='reset' v-on:click='clearLocations()' variant='primary') Limpiar
        b-list-group
          b-list-group-item(v-for="(destination, index) in form.destinations" :key="destination.ICAO")
            b-button.btn-sm.ml-3.float-right(v-if="editable" type='reset' v-on:click='clearLocation(index)' variant='danger') Quitar
            p {{ destination.mensaje }}
            p.small {{ destination.date }} {{ destination.time }}
        //b-form-group#input-group-4(label='Destino:' label-for='checkboxes-4')
          b-form-checkbox-group#checkboxes-4(v-model='form.checked')
            b-form-checkbox(value='me') Check me out
            b-form-checkbox(value='that') Check that out
        h3 Operación
        b-form-group#input-passengerNumber-group(label='Número de pasajeros:' label-for='input-passengerNumber')
          b-form-input#input-passengerNumber(v-model='form.passengerNumber' @change="changePassengerNumber" placeholder='Número pasajeros' type="number"  :disabled="!editable")
        b-form-group#input-addSale-group(label='Copiar datos de cliente:' label-for='input-isClientPassanger')
          b-form-checkbox-group#input-isClientPassanger(v-model='form.isClientPassanger' v-on:change='toggleIsClientPassanger()')
            b-form-checkbox El cliente es pasajero.
        b-form-group#input-passangerGroup-group(label='Pasajeros:' label-for='input-passangerGroup')
            b-card#input-passangerGroup(no-body)
              b-tabs(card)
                b-tab(title="Tab" v-for="passenger in form.passengers" :key="passenger.passengerIndex" active)
                  b-card-text
                  b-form-group#input-passengerType-group(label='Tipo de pasajero:' label-for='input-passengerType')
                    b-form-select#input-passengerType(v-model='passenger.passengerType' required='' :options="passengerTypes" placeholder='Tipo de pasajero' :disabled="!editable")
                  //b-form-group#input-firstName-group(label='Nombres:' label-for='input-firstName')
                    b-form-input#input-firstName(v-model='form.isClientPassanger.length == 1 ? form.firstName : passenger.firstName' required='' placeholder='Nombres del pasajero' :disabled="!editable")
                  //b-form-group#input-lastName-group(label='Apellidos:' label-for='input-lastName')
                    b-form-input#input-lastName(v-model='passenger.lastName' required='' placeholder='Apellidos del pasajero' :disabled="!editable")
                  //b-form-group#input-passengerDocumentType-group(label='Tipo de documento:' label-for='input-passengerDocumentType')
                    b-form-select#input-passengerDocumentType(v-model='passenger.documentType' :options='documentTypes' required='' placeholder='Tipo de documento' :disabled="!editable")
                  //b-form-group#input-passengerDocumentNumber-group(:label='"Número de " + ( passenger.documentType || "documento" ) + ":"' label-for='input-passengerDocumentNumber')
                    b-form-input#input-passengerDocumentNumber(v-model='passenger.documentNumber' required='' placeholder='Número de documento' type="number" :disabled="!editable")
                  b-form-group#input-p-firstName-group(label='Nombres:' label-for='input-p-firstName')
                    vue-bootstrap-typeahead#input-p-firstName(@hit='autofill($event, passenger)' v-model='form.isClientPassanger.length == 1 ? form.firstName : passenger.firstName' required='' placeholder='Nombres del pasajero' :data="clients | readableClients" ref="passengerFirstName" :disabled="!editable")
                  //b-form-group#input-lastName-group(label='Apellidos:' label-for='input-lastName')
                    b-form-input#input-lastName(v-model='form.lastName' placeholder='Apellidos del cliente' :disabled="!editable")
                  b-form-group#input-p-lastName-group(label='Apellidos:' label-for='input-p-lastName')
                    vue-bootstrap-typeahead#input-p-lastName(@hit='autofill($event, passenger)' v-model="passenger.lastName" :data="clients | readableClients" ref="passengerLastName" :disabled="!editable")
                  b-form-group#input-p-documentType-group(label='Tipo de documento:' label-for='input-p-documentType')
                    b-form-select#input-p-documentType(v-model='passenger.documentType' :options='documentTypes' required='' placeholder='Tipo de documento' :disabled="!editable")
                  //b-form-group#input-documentNumber-group(:label='"Número de " + ( form.documentType || "documento" ) + ":"' label-for='input-documentNumber')
                    b-form-input#input-documentNumber(v-model='form.documentNumber' :placeholder='"Número de " + ( form.documentTypeID || "documento" ) ' :disabled="!editable")
                  b-form-group#input-p-documentNumber-group(:label='"Número de " + ( passenger.documentType || "documento" ) + ":"' label-for='input-p-documentNumber' :disabled="!editable")
                    vue-bootstrap-typeahead#input-p-documentNumber(@hit='autofill($event, passenger)' v-model="passenger.documentNumber" :data="clients | readableClients" ref="passengerDocumentNumber" :disabled="!editable")
                  //b-form-group#input-passengerBirthdate-group(:label='"Fecha de nacimiento"' label-for='input-passengerBirthdate')
                    b-form-datepicker#input-passengerBirthdate(v-model="passenger.birthdate" :disabled="!editable")
                  b-form-group#input-passengerBirthdate-group(label='Fecha de nacimiento:' label-for='passengerBirthdate-input' :disabled="!editable")
                    b-input-group#input-passengerBirthdate
                      b-form-input#passengerBirthdate-input(v-model="passenger.birthdate" type="text" placeholder="YYYY-MM-DD" autocomplete="off")
                      b-input-group-append
                        b-form-datepicker#input-passengerBirthdate(v-model="passenger.birthdate" :disabled="!editable" button-only right aria-controls="passengerBirthdate-input")
                  b-form-group#input-passengerEmail-group(label='Correo electrónico:' label-for='input-passengerEmail')
                    b-form-input#input-passengerEmail(v-model='passenger.email' type='email' placeholder='Correo electrónico' :disabled="!editable")
                  b-form-group#input-passengerPhone-group(:label='"Número de teléfono:"' label-for='input-passengerPhone')
                    b-form-input#input-passengerPhone(v-model='passenger.phone' placeholder='Número de teléfono' type="number" :disabled="!editable")
                  b-form-group#input-passengerAddress-group(label='Dirección:' label-for='input-passengerAddress')
                    b-form-input#input-passengerAddress(v-model='passenger.address' placeholder='Dirección de pasajero' :disabled="!editable")
                  b-form-group#input-passengerOccupation-group(label='Ocupación:' label-for='input-passengerOccupation')
                    b-form-input#input-passengerOccupation(v-model='passenger.occupation' placeholder='Ocupación' :disabled="!editable")
                  b-form-group#input-passengerMaritalStatus-group(label='Estado civil:' label-for='input-passengerMaritalStatus')
                    b-form-select#input-passengerMaritalStatus(v-model='passenger.maritalStatus' :options='maritalStatusList' placeholder='Estado civil de pasajero'  :disabled="!editable")
        //b-form-group#input-reservationNumber-group(label='Numero de reservación:' label-for='input-reservationNumber' inline)
          b-form-input#input-reservationNumber(v-model='form.reservationNumber' required='' placeholder='Número de reservación' :disabled="!editable")
        b-form-group#input-airlineCode-group(label='Código de aereolínea:' label-for='input-airlineCode')
          b-form-input#input-airlineCode(v-model='form.airlineCode' placeholder='Código de aereolínea' :disabled="!editable")
        b-form-group#input-currency-group(label='Tipo de moneda:' label-for='input-currency')
          b-form-select#input-currency(v-model='form.currency' required='' :options="currencies" placeholder='Tipo de moneda' :disabled="!editable")
        b-form-group#input-precio-ticket-group(label='Precio del ticket:' label-for='input-precio-ticket' inline)
          b-form-input#input-precio-ticket(v-model='form.ticketPrice' placeholder='Precio del ticket' type="number" step="any" :disabled="!editable")
        b-form-group#input-fee-group(label='Fee:' label-for='input-fee' inline)
          b-form-input#input-fee(v-model='form.fee' placeholder='Fee' type="number" step="any" :disabled="!editable")
        b-form-group#input-total-group(label='Total:' label-for='input-total' inline)
          b-form-input#input-total(disabled v-model='total' placeholder='Total' type="number" step="any" :disabled="!editable")
          //b-input-group-append
            b-input-group-text(class="bg-transparent font-weight-bold") USD
        h3 Venta
        b-form-group#input-addSale-group(label='Añadir venta:' label-for='input-addSale')
          b-form-checkbox-group#input-addSale(v-model='form.hasSale' size="lg")
            b-form-checkbox Incluir información de venta
        b-form-group(v-if="form.hasSale.length == 1")
          b-form-group(v-if="editable")
            b-form-group#input-paymentMethod-group(label='Método de pago:' label-for='input-paymentMethod')
              b-form-select#input-paymentMethod(v-model='form.paymentMethod' :required='form.payments.length == 0' :options="paymentMethods" placeholder='Método de pago' :disabled="!editable && hasSaleId")
            b-form-group#input-paymentCurrency-group(label='Tipo de moneda:' label-for='input-paymentCurrency')
              b-form-select#input-paymentCurrency(v-model='form.paymentCurrency' :required='form.payments.length == 0' :options="currencies" placeholder='Tipo de moneda' :disabled="!editable && hasSaleId")
            b-form-group#input-paymentMethodAmount-group(label='Monto por método de pago:' label-for='input-paymentMethodAmount')
              b-form-input#input-paymentMethodAmount(v-model='form.paymentMethodAmount' :required='form.payments.length == 0' placeholder='Monto por método de pago' type="number" step="any" :disabled="!editable && hasSaleId")
            b-form-group#input-paymentReceiptNumber-group(v-if="form.paymentMethod != 'cash' && !!form.paymentMethod" label='Número de recibo de pago:' label-for='input-paymentReceiptNumber')
              b-form-input#input-paymentReceiptNumber(v-model='form.paymentReceiptNumber' :required='form.payments.length == 0' placeholder='Número de recibo de pago' :disabled="!editable && hasSaleId")
            b-form-group#input-file-group(v-if="form.paymentMethod != 'cash' && !!form.paymentMethod" label='Archivo:' label-for='input-file')
              button#input-file(@click="openUploadModal('paymentReceiptImage')") Subir archivo
              cld-context(cloudName='p1nkx3l')
                cld-image(:publicId='form.paymentReceiptImage')
              //input(type="file" :disabled="!editable && hasSaleId")
            b-form-group#input-paymentButtons(:disabled="!editable && hasSaleId")
              b-button.mr-sm-2(type='button' variant='primary' v-on:click='addPaymentMethod()') Añadir
              b-button(type='reset' v-on:click='clearPaymentMethods()' variant='primary') Limpiar
          b-list-group.mb-3
            b-list-group-item(v-for="(payment, index) in form.payments" :key="payment.id")
              b-button.btn-sm.ml-3.float-right(type='reset' v-on:click='clearPaymentMethod(index)' variant='danger') Quitar
              p {{ getText(payment.method) }}
              p.small Monto {{ payment.currency }} {{ payment.amount }}
              cld-context(cloudName='p1nkx3l')
                cld-image(:publicId='payment.receiptImage')
          //b-form-group#input-saleDate-group(label='Fecha de venta:' label-for='input-saleDate' required='')
            b-form-datepicker#input-saleDate(v-model="form.saleDate" :disabled="!editable && hasSaleId")
          b-form-group#input-saleDate-group(v-if="editable" label='Fecha de venta:' label-for='saleDate-input' :disabled="!editable")
            b-input-group#input-saleDate
              b-form-input#saleDate-input(v-model="form.saleDate" type="text" placeholder="YYYY-MM-DD" autocomplete="off")
              b-input-group-append
                b-form-datepicker#input-locationDate(v-model="form.saleDate" :disabled="!editable" button-only right aria-controls="saleDate-input")
          b-form-group#input-saleDescription-group(label='Anotaciones de venta:' label-for='input-saleDescription')
            b-form-textarea#input-saleDescription(
              v-model="form.saleDescription"
              placeholder="Ingrese anotaciones..."
              rows="4"
              max-rows="6"
              :disabled="!editable && hasSaleId"
            )
          //b-list-group
            b-list-group-item(v-for="(destination, index) in form.destinations") {{ destination.mensaje }}
              b-button.ml-auto(type='reset' variant='danger') Reset
          b-form-group#input-showDetails-group(label='Mostrar detalles:' label-for='input-showDetails')
            b-form-checkbox-group#input-showDetails(v-model='form.showDetails' :disabled="!editable && hasSaleId")
              b-form-checkbox Ingresar detalles de venta
          b-form-group(v-if="form.showDetails.length == 1")
            b-form-group#input-IT-group(label='Número de boleto:' label-for='input-IT' description="*Era para registrar por boleto aéreo")
              b-form-input#input-IT(v-model='form.it' required='' placeholder='Número de boleto' :disabled="!editable && hasSaleId")
            //b-form-group#input-counterReportDate-group(label='Fecha de reporte de counter:' label-for='input-counterReportDate')
              b-form-datepicker#input-counterReportDate(v-model="form.counterReportDate" :disabled="!editable && hasSaleId")
            b-form-group#input-counterReportDate-group(label='Fecha de reporte de counter:' label-for='counterReportDate-inpu' :disabled="!editable")
              b-input-group#input-counterReportDate
                b-form-input#counterReportDate-input(v-model="form.counterReportDate" type="text" placeholder="YYYY-MM-DD" autocomplete="off")
                b-input-group-append
                  b-form-datepicker#input-locationDate(v-model="form.counterReportDate" :disabled="!editable" button-only right aria-controls="counterReportDate-input")
            b-form-group#input-formNumber-group(label='Número de forma:' label-for='input-formNumber' description="Número de Boleto Aereo / Nº Contrato / Voucher / Cotización")
                b-form-input#input-formNumber(v-model='form.formNumber' required='' placeholder='Número de forma' :disabled="!editable && hasSaleId")
            //b-form-group#input-ticketNumber-group(label='Número de boleto:' label-for='input-ticketNumber')
              b-form-input#input-ticketNumber(v-model='form.ticketNumber' required='' placeholder='Número de boleto' :disabled="!editable && hasSaleId")
            //b-form-group#input-counterID-group(label='Counter:' label-for='input-counterID')
              b-form-input#input-counterID(v-model='user.fullName' disabled)
            b-form-group#input-operator-group(label='Operador:' label-for='input-operator')
              b-form-input#input-operator(v-model='form.operator' required='' placeholder='Operador' :disabled="!editable && hasSaleId")
        h3 Resumen
        b-form-group#resume-card-group(label='Resumen de operación:' label-for='resume-card')
          px-card#resume-card(
            :fullName="form.firstName + ' ' + form.lastName"
            :cardHeader="parseInt(form.passengerNumber)"
            :cardFooter="total.toString()"
            :cardContent="{}"
            :hideButtons="true"
          )
          // pre.m-0 {{ form }}
        b-form-group#submit-group
          b-button.mr-sm-2(type='submit' variant='primary') {{ editable || (form.hasSale.length == 1 && !operation.saleId) ? ((hasInfo ? "Actualizar" : "Crear" ) + " operación") : "Editar" }}
            b-spinner.ml-2(v-if="loading" label="Cargando..." small)
          b-button.mr-sm-2(v-if="hasInfo" type='button' variant='secondary' v-on:click='deleteOperation') Eliminar
            b-spinner.ml-2(v-if="deleting" label="Loading..." small)
        b-alert(:show="error" variant="danger") Danger Alert
          //b-button(type='reset' variant='secondary') Añadir venta
        //b-card.mt-3(header='Form Data Result')
            pre.m-0 {{ form }}
</template>

<script>
import { mapState, mapGetters } from "vuex";
//import PxCard from "@/components/PxCard.vue";

import { CldContext, CldImage } from "cloudinary-vue";

export default {
  name: "PxForm",
  components: {
    PxCard: () => import("@/components/PxCard.vue"),
    CldContext,
    CldImage,
  },
  props: {
    airports: Array,
    input: {
      type: Boolean,
      default: true,
    },
    operation: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapState(["user", "clients"]),
    ...mapGetters(["user", "clients"]),
    editable() {
      return this.input || this.isEditable;
    },
    total: {
      // getter
      get: function () {
        return (
          parseFloat(this.form.ticketPrice) + parseFloat(this.form.fee)
        ).toFixed(2);
      },
      // setter
      set: function (newValue) {
        this.form.total = newValue;
      },
    },
  },
  data() {
    return {
      form: {
        firstName: "",
        lastName: "",
        documentType: "",
        documentNumber: "",
        phone: "",
        email: "",
        address: "",
        occupation: "",
        maritalStatus: "single",
        clientId: "",
        passengerNumber: 1,
        isClientPassanger: [],
        passengers: [
          {
            passengerIndex: 0,
            passengerType: undefined,
            firstName: "",
            lastName: "",
            passengerDocumentType: "",
            documentType: undefined,
            documentNumber: "",
            birthdate: "",
            phone: "",
            email: "",
            address: "",
            occupation: "",
            maritalStatus: "single",
          },
        ],
        paymentMethod: "",
        paymentCurrency: "",
        paymentMethodAmount: "",
        paymentReceiptNumber: "",
        paymentReceiptImage: "",
        airlineCode: "",
        currency: "",
        fee: 0,
        ticketPrice: 0,
        total: 0,
        destinations: [],
        payments: [],
        hasSale: [],
        showDetails: [],
        searchLocation: "",
        saleDescription: "",
        counterReportDate: "",
        it: "",
        formNumber: "",
        //ticketNumber: "",
        operator: "",
        saleDate: "",
        isExistingClient: false,
      },
      clientObj: {},
      operationId: "",
      passengerTypes: [
        { text: "", value: null },
        { text: "ADT Adult", value: "adult" },
        { text: "CHD Child", value: "child" },
        { text: "INF Infant without a seat", value: "infant" },
        //"INS infant with a seat",
        //"UNN unaccompanied child",
      ],
      maritalStatusList: [
        //{ text: "", value: null },
        { text: "Soltero", value: "single" },
        { text: "Casado", value: "married" },
        { text: "Viudo", value: "widow" },
        { text: "Divorciado", value: "divorced" },
        //"En relación",
        //"Conviviente",
      ],
      paymentMethods: [
        //{ text: "", value: null },
        { text: "Efectivo", value: "cash" },
        { text: "Tarjeta", value: "credit" },
        { text: "Otros", value: "other" },
      ],
      currencies: [
        { text: "", value: null },
        { text: "Nuevos soles [PEN]", value: "pen" },
        { text: "Dólares americanos [USD]", value: "usd" },
        { text: "Euro [EUR]", value: "eur" },
      ],
      documentTypes: [{ text: "", value: null }, "DNI", "CE", "Pasaporte"],
      counterId: "",
      hasInfo: false,
      hasSaleId: false,
      isEditable: false,
      url: "",
      publicId: "",
      show: true,
      loading: false,
      deleting: false,
      error: false,
      verbose: this.$route.query.dev || this.$route.query.dev === null,
    };
  },
  filters: {
    pluralize: (message, value) => {
      if (!value) return "";
      return value > 1 ? message + "s" : message;
    },
    capitalize: (value) => {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    readableAirports: (array) => {
      return array.map((data) => {
        return (
          (data.IATA != "\\N" ? data.IATA + ", " : "") +
          data.city +
          ", " +
          data.country +
          ", " +
          data.name +
          ", " +
          data.ICAO
        );
      });
    },
    readableClients: (array) => {
      return array.map((data) => {
        return (
          data.firstName +
          " " +
          data.lastName +
          ", " +
          (data.documentType
            ? (data.documentType == "passport"
                ? "Pasaporte"
                : data.documentType.toUpperCase()) + " "
            : "") +
          //data.documentType +
          //" " +
          data.documentNumber
        );
      });
    },
  },
  beforeMount() {
    if (this.operation) {
      this.form.passengerNumber = this.operation.passengerGroup.length;
      this.changePassengerNumber(this.operation.passengerGroup.length);
    }
  },
  updated() {
    if (this.operation) {
      for (let passenger in this.operation.passengerGroup) {
        /*console.log(
          passenger,
          this.$refs,
          this.$refs.passengerFirstName,
          this.$refs.passengerFirstName[passenger]
        );*/
        this.$refs.passengerFirstName[passenger].inputValue =
          this.operation.passengerGroup[passenger].firstName;
        this.$refs.passengerLastName[passenger].inputValue =
          this.operation.passengerGroup[passenger].lastName;
        this.$refs.passengerDocumentNumber[passenger].inputValue =
          this.operation.passengerGroup[passenger].documentNumber;
      }
    }
  },
  mounted() {
    this.$forceUpdate();
    console.log(this.operation);
    if (this.operation) {
      this.operationId = this.operation._id;
      if (this.operation.clientId) {
        this.form.firstName = this.operation.clientId.firstName;
        this.form.lastName = this.operation.clientId.lastName;
        this.form.passengerType = this.operation.clientId.passengerType;
        this.form.documentType = this.documentTypes.find(
          (documentType) =>
            documentType.toUpperCase ==
            this.operation.clientId.documentType.toUpperCase
        );
        this.form.documentNumber = this.operation.clientId.documentNumber;
        this.form.phone = this.operation.clientId.phone;
        this.form.email = this.operation.clientId.email;
        this.form.address = this.operation.clientId.address;
        this.form.occupation = this.operation.clientId.occupation;
        this.form.maritalStatus = this.operation.clientId.maritalStatus;

        this.$refs.firstName.inputValue = this.operation.clientId.firstName;
        this.$refs.lastName.inputValue = this.operation.clientId.lastName;
        this.$refs.documentNumber.inputValue =
          this.operation.clientId.documentNumber;
        //this.$refs.searchLocation = this.operation.clientId.searchLocation;
      }

      this.form.passengers = this.operation.passengerGroup.map((passenger) => {
        passenger.documentType = this.documentTypes.find(
          (documentType) =>
            documentType.toUpperCase == passenger.documentType.toUpperCase
        );
        return passenger;
      });

      if (
        this.operation.routeGroup.length > 0 &&
        this.operation.routeGroup[0].datetime
      ) {
        const destinations = this.operation.routeGroup.map((destination) =>
          (({ ICAO, datetime }) => ({
            ICAO,
            mensaje: this.$options.filters
              .readableAirports([
                this.airports.find(
                  (airport) => airport.ICAO == destination.ICAO
                ),
              ])
              .pop(),
            date: datetime.split("T")[0],
            time: datetime.split("T")[1].split(".")[0],
          }))(destination)
        );

        this.form.destinations = destinations;
        console.log("this.form.destinations", this.operation.destinations);
      }

      this.form.currency = this.operation.currency ?? undefined;
      this.form.fee = this.operation.fee ? this.operation.fee : 0;
      console.log("LOG", this.total, this.operation.total);

      /*this.form.total = this.total ? this.operation.total : 0;*/
      /*this.form.total = this.operation.total || 0;*/
      /*this.form.total = this.total;
      console.log(this.total, this.form.total);*/

      this.form.ticketPrice = (
        parseFloat(this.operation.total || 0) - parseFloat(this.form.fee)
      ).toFixed(2);
      /*this.form.total = this.total;*/

      this.form.payments = this.operation.saleId
        ? this.operation.saleId.paymentMethods
        : [];

      this.form.hasSale = this.operation.saleId ? [true] : [];

      /* sale datail if ( no db ) */
      let hasDetails = this.operation.saleId
        ? !!this.operation.saleId.it ||
          !!this.operation.saleId.counterReportDate ||
          !!this.operation.saleId.formNumber ||
          !!this.operation.saleId.operator
        : false;

      if (hasDetails) {
        this.form.showDetails = [true];
        this.form.it = this.operation.saleId.it ?? undefined;
        this.form.counterReportDate =
          this.operation.saleId.counterReportDate ?? undefined;
        this.form.formNumber = this.operation.saleId.formNumber ?? undefined;
        this.form.operator = this.operation.saleId.operator ?? undefined;
      }

      this.hasInfo = !!this.operation;
      this.hasSaleId = !!this.operation.saleId;
      this.counterId = this.$store.getters.user.id;

      if (this.hasSaleId) {
        this.form.saleDescription = this.operation.saleId.saleDescription ?? "";
      }
    }
  },
  methods: {
    openUploadModal(attribute) {
      window.cloudinary
        .openUploadWidget(
          {
            cloud_name: "p1nkx3l",
            upload_preset: "ml_default",
          },
          (error, result) => {
            if (!error && result && result.event === "success") {
              console.log("Done uploading..: ", result.info);
              this.form[attribute] = result.info.public_id;
              //this.publicId = result.info.public_id;
            }
          }
        )
        .open();
    },
    async onSubmit(event) {
      event.preventDefault();
      try {
        this.loading = true;
        if (this.editable) {
          this.form.total = this.total;
          if (this.hasInfo) {
            this.form.id = this.operationId;
            console.log(this.form.total);
            console.log("updateOperation");
            await this.$store.dispatch("updateOperation", this.form);
          } else {
            console.log("addOperation");
            await this.$store.dispatch("addOperation", this.form);
          }
          this.isEditable = false;
        } else {
          this.isEditable = true;
        }
        window.scrollTo(0, 0);
      } catch (error) {
        console.log(error);
        this.error = true;
      } finally {
        console.log("operationSubmited");
        this.loading = false;
      }

      /*alert(this.form);
      this.$store.dispatch("addOperation", {
        clientId: {
          firstName: this.form.firstName,
        },
        passangerGroupID: {
          passengerNumber: this.form.passengerNumber,
        },
      });
      //this.$store.dispatch("loadItems");
      alert(JSON.stringify(this.form));*/
    },
    onReset(evt) {
      evt.preventDefault();
      console.log(this.$store);

      console.log("GETR");

      console.dir(this.$store.getters.airports);
      console.dir(this.airports);

      // Reset our form values
      this.form.email = "";
      this.form.name = "";
      this.form.food = null;
      this.form.checked = [];
      // Trick to reset/clear native browser form validation state
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
    addLocation() {
      this.form.destinations.push({
        ICAO: this.form.searchLocation.split(",").pop().trim(),
        mensaje: this.form.searchLocation,
        date: this.form.locationDate,
        time: this.form.locationTime,
      });
      //this.form.searchLocation = undefined;
      this.$refs.searchLocation.inputValue = "";
      this.form.locationDate = null;
      this.form.locationTime = null;
    },
    addPaymentMethod() {
      this.form.payments.push({
        id: this.form.payments.length,
        method: this.form.paymentMethod,
        currency: this.form.paymentCurrency,
        amount: this.form.paymentMethodAmount,
        receiptNumber: this.form.paymentReceiptNumber,
        receiptImage: this.form.paymentReceiptImage,
      });
      //this.$refs.searchLocation.inputValue = "";
      this.form.paymentMethod = null;
      this.form.paymentMethodAmount = null;
      this.form.paymentCurrency = null;
    },
    getText(value) {
      return this.paymentMethods.find((method) => method.value == value).text;
    },
    clearLocations() {
      this.form.destinations = [];
    },
    clearLocation(index) {
      this.form.destinations.splice(index, 1);
    },
    clearPaymentMethod(index) {
      this.form.payments.splice(index, 1);
    },
    clearPaymentMethods() {
      this.form.payments = [];
    },
    async deleteOperation() {
      console.log("PxForm", this.operationId);
      try {
        this.deleting = true;
        await this.$store.dispatch("deleteOperation", this.operationId);
      } catch (error) {
        console.log(error);
        this.error = true;
      } finally {
        console.log("operationDeleted");
        this.deleting = false;
        this.$router.push({ path: "/" });
      }
    },
    changePassengerNumber(value) {
      let val = parseInt(value);
      let more = val > this.form.passengers.length;
      console.log(val, this.form.passengers.length);
      if (more) {
        for (let i = this.form.passengers.length; i < val; i++) {
          let newPassenger = { ...this.form.passengers[0] };
          newPassenger.passengerIndex = i;
          this.form.passengers[i] = newPassenger;
          this.$forceUpdate();
        }
      } else {
        console.log(val, this.form.passengers.length);
        for (let i = this.form.passengers.length; i > val; i--) {
          this.form.passengers.pop();
          this.$forceUpdate();
        }
        console.log(this.form.passengers);
      }
    },
    autofill(client, form) {
      console.log("client", client);
      console.log("form", form);

      let isPassanger = form;
      console.log(isPassanger);

      this.clientObj = this.clients.find((cli) => {
        this.form.isExistingClient = true;
        let documentTypeView = client.split(",")[1].trim().split(" ")[0];
        let documentType =
          documentTypeView == "Pasaporte"
            ? "passport"
            : documentTypeView.toLowerCase();
        return (
          parseInt(cli.documentNumber) ===
            parseInt(client.replace(/^\D+/g, "")) &&
          cli.documentType == documentType
        );
      });

      if (this.clientObj._id !== undefined) {
        form.clientId = this.clientObj._id;
        for (const property in this.clientObj) {
          if (property in form) {
            if (property != "documentType") {
              form[property] = this.clientObj[property];
            } else {
              form[property] = this.getDocumentType(this.clientObj);
              //this.form.passengers[0][property] = documentType;
            }
          }
          if (property in this.$refs) {
            console.log(this.$refs);
            this.$refs[property].inputValue = this.clientObj[property];
          }
        }
      }
    },
    toggleIsClientPassanger() {
      if (this.form.isClientPassanger[0] !== true) {
        // Cliente es pasajero

        if (this.clientObj._id !== undefined) {
          for (const property in this.clientObj) {
            if (property in this.form) {
              if (property != "documentType") {
                this.form.passengers[0][property] = this.form[property];
              } else {
                this.form.passengers[0][property] = this.getDocumentType(
                  this.clientObj
                );
              }
            }
            if (property in this.$refs) {
              let passengerProperty =
                "passenger" +
                property.charAt(0).toUpperCase() +
                property.slice(1);

              console.log(this.$refs[passengerProperty]);
              if (this.$refs[passengerProperty]) {
                console.log(
                  "TRUE",
                  passengerProperty,
                  this.$refs[passengerProperty]
                );
                this.$refs[passengerProperty][0].inputValue =
                  this.clientObj[property];
              }
            }
          }
        } else {
          // TODO: cliente nuevo es pasajero
          console.log("cliente es nuevo y es pasajero");

          this.$refs["passengerFirstName"][0].inputValue =
            this.$refs["firstName"].inputValue;
          this.$refs["passengerLastName"][0].inputValue =
            this.$refs["lastName"].inputValue;
          this.form.passengers[0].documentType = this.form.documentType;
          this.$refs["passengerDocumentNumber"][0].inputValue =
            this.$refs["documentNumber"].inputValue;
          this.form.passengers[0].email = this.form.email;
          this.form.passengers[0].phone = this.form.phone;
          this.form.passengers[0].address = this.form.address;
          this.form.passengers[0].occupation = this.form.occupation;
          this.form.passengers[0].maritalStatus = this.form.maritalStatus;
        }
      } else {
        // Cliente NO es pasajero
        console.log("cliente no es pasajero");
        this.$refs["passengerFirstName"][0].inputValue = undefined;
        this.$refs["passengerLastName"][0].inputValue = undefined;
        this.form.passengers[0].documentType = undefined;
        this.$refs["passengerDocumentNumber"][0].inputValue = undefined;
        this.form.passengers[0].email = undefined;
        this.form.passengers[0].phone = undefined;
        this.form.passengers[0].address = undefined;
        this.form.passengers[0].occupation = undefined;
        this.form.passengers[0].maritalStatus = undefined;
      }
    },
    getDocumentType(clientObj) {
      return this.documentTypes.find(
        (documentType) =>
          documentType ==
          (clientObj["documentType"] == "passport"
            ? "Pasaporte"
            : clientObj["documentType"].toUpperCase())
      );
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus">
.cld-image img
  width: 100%
  margin-top: 1em
</style>
